import { observer } from "mobx-react";
import { useEffect } from "react";
import { useTamariskPaymentsStore } from "../hooks/useTamariskPaymentsStore";
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme)=>
  createStyles({
    amcPaymentIframe: {
      border:0,
      height: '1060px',
      width: '100%',
    }
  })
)

interface AmcPaymentInterface {
  loanId?: string;
};

export const AmcAppraisalPaymentContainer = observer((props: AmcPaymentInterface)=>{
  const { tamariskPaymentsStore } = useTamariskPaymentsStore();
  const { loanId } = props;
  const classes = useStyles();
  useEffect(()=>{
    tamariskPaymentsStore.fetchPaymentLink(loanId);
  },[])
  return (
    <iframe
      className={classes.amcPaymentIframe}
      src={tamariskPaymentsStore.amcPaymentLink}
    />
  )
})